document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    // Delegated so it works after main-tab swaps.
    page.addEventListener('click', (e) => {

        // Copy referral code to clipboard.
        const copyBtn = e.target.closest('[data-rf-copy]');
        if (copyBtn) {
            e.preventDefault();
            const card = copyBtn.closest('.myaccount__rf-card--code');
            const codeEl = card && card.querySelector('[data-rf-code]');
            const code = codeEl ? (codeEl.dataset.rfCode || codeEl.textContent.trim()) : '';
            if (!code) return;
            const original = copyBtn.textContent;

            const onDone = () => {
                copyBtn.classList.add('is-copied');
                copyBtn.textContent = 'Copied!';
                setTimeout(() => {
                    copyBtn.classList.remove('is-copied');
                    copyBtn.textContent = original;
                }, 1500);
            };

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(code).then(onDone).catch(() => fallbackCopy(code, onDone));
            } else {
                fallbackCopy(code, onDone);
            }
            return;
        }

        // Toggle active state on the history filter pills (UI-only for now).
        const filterBtn = e.target.closest('[data-rf-history-filter]');
        if (filterBtn) {
            e.preventDefault();
            const wrap = filterBtn.parentElement;
            if (!wrap) return;
            wrap.querySelectorAll('[data-rf-history-filter]').forEach((b) => {
                const isOn = b === filterBtn;
                b.classList.toggle('is-active', isOn);
                b.setAttribute('aria-selected', isOn ? 'true' : 'false');
            });
        }
    });

    function fallbackCopy(text, done) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (_) {}
        document.body.removeChild(ta);
        done && done();
    }
});
